





























































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { memberCountInfo } from "@/api/vip";
import { selectAllLabel } from "@/api/discount";
import { selectOperation } from "@/api/operation";
@Component
export default class Header extends Vue {
  @Prop() fromDate: string = ""; // 注册开始日期
  @Prop() shopName: string = ""; // 企业名称
  @Prop() phone: string = ""; // 手机号码
  @Prop() userName: string = ""; // 客户名称
  @Prop() recentExpenseBeginTime: string = ""; //最近的消费开始时间
  cardTypeArr: Array<any> = [];
  newMemberCount = 0;
  totalCount = 0;
  selectCardTypeArr = [];


  operationSubCompanyId: number|null = null;
  operationServiceId: number|null = null;
  operationMemberId: number|null = null;
  subCompanyList: Array<any> = [];
  serviceList: Array<any> = [];
  memberList: Array<any> = [];

  getSubCompany(str:any){
    if(typeof str == 'object'){
      str = '';
    }
    selectOperation({
      roleType:2,
      roleName:str
    }).then((res: any) => {
      this.subCompanyList = res.data;
    });
  }

  getService(str:any){
    if(typeof str == 'object'){
      str = '';
    }
    selectOperation({
      parentId:this.operationSubCompanyId,
      roleType:3,
      roleName:str
    }).then((res: any) => {
      this.serviceList = res.data;
    });
  }

  getMember(str:any){
    if(typeof str == 'object'){
      str = '';
    }
    selectOperation({
      parentId:this.operationServiceId,
      roleType:4,
      roleName:str
    }).then((res: any) => {
      this.memberList = res.data;
    });
  }
  
  @Watch('operationSubCompanyId')
  toSubCompanyId(val:number) {
    this.$emit('input', val, 'subCompanyId')
  }
  @Watch('operationServiceId')
  toServiceId(val:number) {
    this.$emit('input', val, 'serviceId')
  }
  @Watch('operationMemberId')
  toOperationMemberId(val:number) {
    this.$emit('input', val, 'operationMemberId')
  }
  

  mounted() {
    selectAllLabel().then((res: any) => {
      this.cardTypeArr = res.data;
    });
    memberCountInfo().then((res: any) => {
      this.newMemberCount = res.data.newMemberCount;
      this.totalCount = res.data.totalCount;
    });
  }

  selectcardType(val: any) {
    this.$emit('input', val.join(','), 'cardType');
  }
}
